import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VerifyEmailService } from '../../verify-email/services/verify-email.service';
import { AuthService } from '../../verify-email/services/auth.service';


@Component({
  selector: 'app-passwordvalidation',
  templateUrl: './passwordvalidation.component.html',
  styleUrls: ['./passwordvalidation.component.css']
})
export class PasswordvalidationComponent implements OnInit {
  public showPassword: boolean;
  public profileForm: FormGroup;
  public showPasswordOnPress: boolean;
  isValidLink: boolean = false;
  isPasswordValid: boolean = true;
  validLinkMessage: any = '';
  linkGuid: any = '';
  warningMessage: string = 'Sorry! The Password you have entered is incorrect. You have (Number_of_attempts) more attempts left!';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private verifyEmailService: VerifyEmailService,
    private authService: AuthService
  ) {
    this.profileForm = this.fb.group({
      password: ['']
    });

    this.route.queryParams.subscribe(params => {
      const id = encodeURIComponent(params['id']);
      this.linkGuid = id;
      this.verifyEmailService.passwordValidationLink(id).subscribe(res => {
        if (res && res.data) {
          this.isValidLink = res.data.errorCode === 1 ? true : false;
          this.validLinkMessage = res.data.msg;
        }
      });
    });
  }

  ngOnInit() {}

  closeAlert() {}

  confirm() {    
    const password = this.profileForm.get('password').value;
    this.authService.checkPasswordValidaOrNot(this.linkGuid, password).subscribe(res=>{      
      if(res.data.errorCode === 1) {
        this.isPasswordValid = true;
        this.router.navigate(['/uploadDocuments/' + this.linkGuid]);
        }
        else{
        this.isPasswordValid = false;
        this.warningMessage = res.data.msg;
       }
      }
    );
  }
}
